import { DocumentTypeEnum } from '__generated__/graphql';

export default function cvlDocumentTypeToReadable(type: DocumentTypeEnum): string {
  switch (type) {
    case DocumentTypeEnum.Pan:
      return 'PAN Card';
    case DocumentTypeEnum.IdentityProof:
      return 'Identity Proof';
    case DocumentTypeEnum.ItrAcknowledgementYear_1:
      return 'ITR Acknowledgement (Year 1)';
    case DocumentTypeEnum.ItrAcknowledgementYear_2:
      return 'ITR Acknowledgement (Year 2)';
    case DocumentTypeEnum.NetWorthCertificateYear_1:
      return 'Net Worth Certificate (Year 1)';
    case DocumentTypeEnum.NetWorthCertificateYear_2:
      return 'Net Worth Certificate (Year 2)';
    case DocumentTypeEnum.Undertaking:
      return 'Undertaking';
    default:
      return type;
  }
}
